import React, { useState } from 'react';
import { IconButton, Grid, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import DeleteIcon from '@mui/icons-material/Delete';
import history from '../../router/history';
import routes from '../../constants/Routes';
import * as utils from '../../util/bellplus-utils';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import locationDefault from '../../images/locationdefault.jpg';
import { ButtonBase } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Template } from '@horasys/bellplus/common/types';
import AlertBox from 'views/Common/AlertBox';
import { useNavigate } from 'react-router-dom';

const PREFIX = 'TemplateCardList';

const classes = {
	root: `${PREFIX}-root`,
	media: `${PREFIX}-media`,
	dummyCard: `${PREFIX}-dummyCard`,
	buttonBase: `${PREFIX}-buttonBase`,
	adCard: `${PREFIX}-adCard`,
};
const Root = styled('div')(({ theme }) => ({
	[`& .${classes.root}`]: {
		maxWidth: 345,
	},

	[`& .${classes.media}`]: {
		height: 230,
		backgroundSize: '50%',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat',
	},

	[`& .${classes.dummyCard}`]: {
		padding: theme.spacing(2),
		maxHeight: 400,
	},

	[`& .${classes.buttonBase}`]: {
		minWidth: '100%',
		minHeight: '100%',
		backgroundColor: '#ececec',
	},

	[`& .${classes.adCard}`]: {
		padding: theme.spacing(2),
	},
}));

const TemplateCardList = (props: any) => {
	const { templatesList, alertError, roleAction, onDeleteClicked } = props;

	const [, setOpenModalDelete] = useState(false);
	const [, setTemplateId] = useState(0);

	const navigate = useNavigate();

	const openViewModal = (rowData: any) => {
		utils.setData('templateId', rowData.id !== undefined ? rowData.id : 0);
		utils.setData('mode', 'VIEW');
		navigate(routes.VIEW_TEMPLATE.path);
	};

	const openCreateClientModal = () => {
		utils.setData('mode', 'CREATE');
		navigate(routes.CREATE_TEMPLATE.path);
	};

	const openDeleteModal = (rowData: any) => {
		setTemplateId(rowData.id);
		setOpenModalDelete(true);
		onDeleteClicked(rowData.id);
	};

	const openEditModal = (rowData: any) => {
		utils.setData('templateId', rowData.id !== undefined ? rowData.id : 0);
		utils.setData('mode', 'EDIT');
		history.push(routes.EDIT_TEMPLATE.path);
	};

	const TemplateCard = ({ template }: { template: Template }) => (
		<Grid item xs={3} className={classes.adCard}>
			<Card className={classes.root}>
				<CardHeader
					title={template.name}
					subheader={`Resolution: ${template.deviceType.width} x ${template.deviceType.height}`}
				/>
				<CardMedia
					className={classes.media}
					image={template.templateUrl ? template.templateUrl : locationDefault}
				/>

				<CardActions disableSpacing>
					<IconButton
						aria-label="View"
						onClick={() => openViewModal(template)}
						size="large">
						<VisibilityIcon />
					</IconButton>

					{roleAction.edit ? (
						<IconButton
							aria-label="Edit"
							onClick={() => openEditModal(template)}
							size="large">
							<EditIcon />
						</IconButton>
					) : null}

					{roleAction.delete ? (
						<IconButton
							aria-label="Delete"
							onClick={() => openDeleteModal(template)}
							size="large">
							<DeleteIcon />
						</IconButton>
					) : null}
				</CardActions>
			</Card>
		</Grid>
	);

	return (
		<Root>
			<ToastsContainer
				className="toast"
				store={ToastsStore}
				position={ToastsContainerPosition.TOP_CENTER}
			/>
			<AlertBox
				message={alertError.message}
				shouldOpen={alertError.open}
				type="warning"
			/>
			<Grid container>
				{roleAction.create ? (
					<Grid
						container
						item
						xs={3}
						className={classes.dummyCard}
						justifyContent="center"
						alignItems="center">
						<ButtonBase
							className={classes.buttonBase}
							onClick={openCreateClientModal}>
							<Tooltip title="Add Custom Template" placement="right-start">
								<AddCircleOutlineIcon
									color="primary"
									style={{ fontSize: 60, color: '#042630' }}
								/>
							</Tooltip>
						</ButtonBase>
					</Grid>
				) : null}
				{templatesList &&
					templatesList.map((template: Template) => (
						<TemplateCard key={template.id} template={template} />
					))}
			</Grid>
		</Root>
	);
};

export default TemplateCardList;
